const reportBaseURL = "https://ovcodedevapim.ovcode.com/proxy-reports"
const baseURL = "https://ovcodedevapim.ovcode.com/proxy-analytics"
const subscriptionKey = "6ecb84a6af404b2296ab0166f82df7ca"
const notificationBaseURL = "https://ovcodedevapim.ovcode.com/proxy-notification"
const notificationSubscriptionKey = "5792630dffea49daba0bbb7fbd3d0d3f"

// const website_URL = "http://localhost:4500"
const website_URL = "https://dev-ovguard.ovcode.com"

export default {
    
    service_baseUrl: {
        url: baseURL ,
        subscriptionKey: subscriptionKey,
    },

    reports_service_baseUrl: {
        url: reportBaseURL ,
        subscriptionKey: subscriptionKey,
    },

    notification_service_baseUrl: {
        url: notificationBaseURL ,
        subscriptionKey: notificationSubscriptionKey,
    },

    mapBox: {
        mapBoxToken: "pk.eyJ1Ijoib3Zjb2RlZGV2IiwiYSI6ImNsejZtdXl0ZzBmaHYybHEyOXE3azI2ZW0ifQ.Qk4mV1e-VeuLu3ar3RX7-g"
    },

    msal_url : {
        url: website_URL,
    },

    msal_change_password_url : {
        // url: changePassword_URL,
    },

    msal_authConfig:{
        // clientId:'31d883ba-e9e9-4c98-9aaf-799830f0780c', 
        // knownAuthorities: ["ovcodeuser.b2clogin.com"], 
        // authority:'https://ovcodeuser.b2clogin.com/tfp/ovcodeuser.onmicrosoft.com/B2C_1_ovcode_test', 
        clientId:'46b14da4-be36-4760-9474-742a3de92ec2',
        knownAuthorities: ["msovcode.b2clogin.com"],
        authority:'https://msovcode.b2clogin.com/tfp/msovcode.onmicrosoft.com/B2C_1_ovcode_login',
        redirectUri: website_URL,
        postLogoutRedirectUri: website_URL,
    },
    
    b2c_scope:{ 
        scopes:[
            // "https://ovcodeuser.onmicrosoft.com/31d883ba-e9e9-4c98-9aaf-799830f0780c/User" 
             "https://msovcode.onmicrosoft.com/46b14da4-be36-4760-9474-742a3de92ec2/User"
        ]
        
    } 

}